import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstfnb: [],
		fnb: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		isLiquidation: false,
		hasNext: false,
		lastUpdatedRegister: null,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getfnb(state) {
			let fnb = { ...state.fnb }
			return fnb
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, fnb) {
			state.fnb = fnb
			if (fnb) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.fnb = null
		},
		setParamsDataTable(state, payload) {
			state.lstfnb = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setfnb(state, fnb) {
			state.fnb = fnb
		},
		setLstfnb(state, lstfnb) {
			state.lstfnb = lstfnb
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Financial/CheckDeposit/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstfnb", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async find({ commit, dispatch }, { fnbdoc, fnbbanco, fnbagencia, fnbcompens, fnbcheque, fnbconta }) {
			commit("setLoading", true)
			commit("initForm")
			try {
				const response = await this._vm.$axios.get(
					`/Financial/CheckDeposit/Find/${fnbdoc}/${fnbbanco}/${fnbagencia}/${fnbcompens}/${fnbcheque}/${fnbconta}`
				)

				let fnb = Utils.ValidateAxiosResponse(response.data)
				if (fnb) {
					commit("set", fnb)
					commit("setLoading", false)
					return true
				} else {
					commit("setLoading", false)
					return false
				}
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true }
				)
				commit("setLoading", false)
				return false
			}
		},

		async save({ getters, dispatch, state }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/Financial/CheckDeposit/Insert", getters.getfnb)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					commit("setfnb", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/Financial/CheckDeposit/Update", getters.getfnb)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }, fnb) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Financial/CheckDeposit/Delete/${fnb.fnbdoc}/${fnb.fnbbanco}/${fnb.fnbagencia}/${fnb.fnbcompens}/${fnb.fnbcheque}/${fnb.fnbconta}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
	},
}
